var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCapitales({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.88 13.198a.47.47 0 00-.483.457v4.059c0 .757-.648 1.37-1.447 1.371H2.412c-.799 0-1.446-.614-1.447-1.371V5.803c0-.757.648-1.37 1.447-1.371h4.284a.47.47 0 00.483-.457.47.47 0 00-.483-.457H2.412C1.081 3.519.002 4.54 0 5.803v11.91C.001 18.977 1.08 19.999 2.412 20H15.95c1.331-.001 2.41-1.023 2.412-2.285v-4.059a.47.47 0 00-.482-.457"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.538 3.401l-.512.485-2.272-2.152.512-.485a1.254 1.254 0 011.706 0l.566.536c.47.447.47 1.17 0 1.616zM7.574 9.917l1.815 1.72-2.511.658.696-2.378zm.453-.863l7.045-6.674 2.272 2.152-7.045 6.674-2.272-2.152zM18.654.602a2.257 2.257 0 00-3.07 0L6.976 8.757a.452.452 0 00-.124.201L5.72 12.83a.44.44 0 00.124.446.501.501 0 00.47.117l4.087-1.073a.49.49 0 00.212-.117l8.607-8.154a1.983 1.983 0 000-2.91l-.566-.536z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCapitales);
export default __webpack_public_path__ + "static/media/icon_capitales.747e6bb0152530cf99fb104c28398c9e.svg";
export { ForwardRef as ReactComponent };